var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9227 0.999958C13.9972 0.999958 10 4.97995 10 9.90136C10 14.8228 13.9895 18.8027 18.9227 18.8027L18.9227 1.00762L18.9227 0.999958Z",
    stroke: "#0D529D",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92274 0.999958C4.9972 0.999958 0.999999 4.97995 1 9.90136C1 14.8228 4.98953 18.8027 9.92274 18.8027L9.92274 1.00762L9.92274 0.999958Z",
    stroke: "#0D529D",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.629 9.90262C29.629 7.1381 27.3825 4.89699 24.6114 4.89699C21.8402 4.89699 19.5937 7.1381 19.5937 9.90262C19.5937 12.6671 21.8402 14.9082 24.6114 14.9082C27.3825 14.9082 29.629 12.6671 29.629 9.90262Z",
    stroke: "#0D529D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimary);
export default __webpack_public_path__ + "static/media/primary.29e1b8025e538affe009ad68113fa7d3.svg";
export { ForwardRef as ReactComponent };